import React from "react";

export default React.createContext({
    categories: null,
    footerLin: null,
    webshopName: null,
    logoUrl: null
});
 